const IconSchool = () => {
    return (
        <svg
            width="47"
            height="47"
            viewBox="0 0 47 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M23.5002 5.875L1.9585 17.625L9.79183 21.8942V33.6442L23.5002 41.125L37.2085 33.6442V21.8942L41.1252 19.7596V33.2917H45.0418V17.625L23.5002 5.875ZM36.856 17.625L23.5002 24.91L10.1443 17.625L23.5002 10.34L36.856 17.625ZM33.2918 31.3137L23.5002 36.66L13.7085 31.3137V24.0288L23.5002 29.375L33.2918 24.0288V31.3137Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconSchool;
